import { Text, Flex, ThemeIcon } from "@mantine/core"
import { IconSparkles } from "@tabler/icons-react"

import { DropdownItemProps } from "@costory/types/endpoints/DropdownTypes"

import { ICON_SIZE, ICON_STROKE } from "@costory/shared/const"

const DropDownItem = ({
  item,
  index,
  selectedValue,
  highlightedIndex,
  hoveredValue,
  onHover,
  onClick,
  menuItemStyle,
  groupKey,
  getIcon,
  hasSuggestedAxes,
}: DropdownItemProps) => {
  const isSelected = item.value === selectedValue
  const isHighlighted = index === highlightedIndex
  const isHovered = hoveredValue === item.value
  const isGrayedOut = item.isGrayedOut // New property to check if item is grayed out

  const itemStyle = {
    ...menuItemStyle.base,
    ...(isHovered || isSelected || isHighlighted ? menuItemStyle.selected : {}),
  }

  return (
    <Text
      key={`${groupKey}-${item.value}-${index}`}
      data-index={index}
      onMouseEnter={() => onHover(item.value)}
      onMouseLeave={() => onHover(null)}
      onClick={() => onClick(item.value)}
      px="xs"
      py={6}
      bg={
        isHovered || isSelected || isHighlighted
          ? "surfaceHover"
          : "transparent"
      }
      c={
        isGrayedOut
          ? "dimmed" // Grayed out items should be dimmed
          : !item.isSuggested && hasSuggestedAxes
            ? "textDisabled"
            : undefined
      }
      opacity={isGrayedOut ? 0.6 : 1} // Make grayed out items more transparent
      style={{
        ...itemStyle,
        cursor: isGrayedOut ? "not-allowed" : "pointer", // Show not-allowed cursor for grayed out items
        transition: "transform 0.15s ease, background-color 0.15s ease",
        borderRadius: 4,
      }}
    >
      <Flex align="center" gap={6}>
        {getIcon?.(item.value)}
        {item.label}
        {item.isSuggested && (
          <ThemeIcon
            size={ICON_SIZE}
            color="primaryHighlight"
            variant="transparent"
            style={{ marginLeft: 4 }}
          >
            <IconSparkles stroke={ICON_STROKE} />
          </ThemeIcon>
        )}
      </Flex>
    </Text>
  )
}

export default DropDownItem
